// src/utils/tikpontos.js
// Funções compartilhadas pelas páginas do cliente.
// Antes cada página tinha sua própria versão destas regras, com pequenas
// diferenças (a Home calculava pontos de um jeito e o Catálogo de outro).

import { BASE_URL } from "../axiosConfig";

// Um valor por carregamento de página: a imagem é baixada de novo quando o
// cliente recarrega o painel (para pegar fotos trocadas no admin), mas não a
// cada nova renderização, como acontecia antes no Catálogo.
const CACHE_IMAGENS = Date.now();

export function getImagemUrl(img, { semCache = false } = {}) {
  if (!img) return "";
  let url = String(img);

  // Corrige URLs gravadas com localhost (dados antigos)
  url = url.replace(/^http:\/\/localhost:\d+/, BASE_URL);

  if (!url.startsWith("http")) {
    url = `${BASE_URL}/${url.replace(/^\/+/, "")}`;
  }

  if (semCache) return url;
  return url.includes("?") ? `${url}&v=${CACHE_IMAGENS}` : `${url}?v=${CACHE_IMAGENS}`;
}

export function estaEmPromocao(premio, hoje = new Date()) {
  if (!premio) return false;
  return Boolean(
    premio.valor_em_pontos_promocional &&
      premio.promocao_inicio &&
      premio.promocao_fim &&
      new Date(premio.promocao_inicio) <= hoje &&
      hoje <= new Date(premio.promocao_fim)
  );
}

// Mesma regra usada no Carrinho (que é quem fecha o resgate):
// 1) preço promocional vigente; 2) valor_em_pontos; 3) cálculo pelo preço.
export function calcularPontosPremio(premio, valorPonto = 0.03) {
  if (!premio) return 0;
  if (estaEmPromocao(premio)) {
    return parseInt(premio.valor_em_pontos_promocional, 10) || 0;
  }
  if (premio.valor_em_pontos) {
    return parseInt(premio.valor_em_pontos, 10) || 0;
  }
  const vp = Number(valorPonto) || 0.03;
  return Math.ceil((Number(premio.preco_unitario || 0) * 1.2) / vp);
}

// Pontos "cheios" (sem promoção), para mostrar riscado
export function pontosSemPromocao(premio, valorPonto = 0.03) {
  if (!premio) return 0;
  if (premio.valor_em_pontos) return parseInt(premio.valor_em_pontos, 10) || 0;
  const vp = Number(valorPonto) || 0.03;
  return Math.ceil((Number(premio.preco_unitario || 0) * 1.2) / vp);
}

export function premioDisponivel(premio) {
  if (!premio) return false;
  if (premio.estoque === null || premio.estoque === undefined || premio.estoque === "") {
    return true;
  }
  return Number(premio.estoque) > 0;
}

export function exigeVoltagem(premio) {
  return Number(premio?.exige_voltagem || 0) === 1;
}

export function formatarPontos(valor) {
  return Math.round(Number(valor || 0)).toLocaleString("pt-BR");
}

export function lerUsuario() {
  try {
    return JSON.parse(localStorage.getItem("usuario")) || null;
  } catch {
    return null;
  }
}

export function primeiroNome(nome) {
  return String(nome || "").trim().split(/\s+/)[0] || "";
}

// Remove acentos e deixa minúsculo (usado nas buscas)
export function normalizarTexto(texto) {
  return String(texto || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
